import { assertSkillContentEditable } from "../skillGitUpdates";
import * as z from "zod";
import { writeSkillMd } from "../skillFiles";
import { mutator } from "./mutator";

const updateSkillSchema = z.object({
  skillId: z.string(),
  name: z.string(),
  description: z.string(),
  instructions: z.string(),
  enabled: z.boolean(),
});

export const updateSkill = mutator({
  schema: updateSkillSchema,
  resolve: {
    skill: { kind: "skill", from: "skillId" },
  },
  permissions: [
    {
      permission: "skill:write",
      scopeId: ({ args }) => args.skill.id,
    },
  ],
  description:
    "Updates a custom skill's name, description, instructions, or enabled state.",
  interactionType: "update",
  fn: async ({
    tx,
    ctx,
    args: { skill, name, description, instructions, enabled },
  }) => {
    await assertSkillContentEditable(tx, skill.id);
    const content = {
      name: name.trim(),
      description: description.trim(),
      instructions,
    };
    await tx.mutate.skills.update({
      id: skill.id,
      ...content,
      enabled,
    });
    await writeSkillMd(tx, skill.id, ctx.tenantId, content);
  },
});
